export default {
  footerQuickLinks: "Quick Links",
  footerAboutRLS: "About RLS",
  footerOurJourney: "Our Journey",
  footerLeadershipTeam: "Leadership Team",
  footerContactUs: "Contact Us",
  footerConnectWithUs: "Connect With Us",
  footerAllRightsReserved: "2025 Refex Life Sciences. All rights reserved.",
  footerPrivacyPolicy: "Privacy Policy",
  footerTermsOfService: "Terms of Service",
};

